import Accordion from "react-bootstrap/Accordion";
import "./Accordion.styles.css";

const CustomAccordion: React.FC<{
  title: string;
  data: JSX.Element;
  isOpen: boolean;
  toggleAccordion: () => void;
  id?: string;
}> = ({ title, data, isOpen, toggleAccordion, id = "" }) => {
  return (
    <Accordion defaultActiveKey={isOpen ? "0" : undefined} id={id}>
      <Accordion.Item eventKey="0">
        <Accordion.Header onClick={toggleAccordion}>{title}</Accordion.Header>
        <Accordion.Body>{data}</Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};

export default CustomAccordion;
